<template>
  <Tippy
    ref="popover"
    trigger="click"
    interactive
    theme="light"
    placement="bottom"
  >
    <template #trigger>
      <div
        class="sort-option-selected"
        :class="invalid ? 'invalid' : ''"
      >
        <CategoryInfo
          v-if="selected"
          :category-id="selected"
          style="font-size: 1rem"
        />
        <div v-else>
          ?
        </div>
      </div>
    </template>

    <div style="min-width: 180px">
      <div
        v-for="(s, i) in categoryOptions"
        :key="s.key"
        class="sort-option text-left d-flex"
        :class="{
          first: i === 0,
          active: selected === s.key
        }"
        @click="$emit('update:selected', s.key); $refs.popover.tippy().hide()"
      >
        <div class="flex-grow-1">
          <CategoryInfo
            class="category-row"
            :category-id="s.key"
          />
        </div>
      </div>
    </div>
  </Tippy>
</template>

<script>
import CategoryInfo from '@/components/CategoryInfo';
import { mapGetters } from 'vuex';

export default {
  props: {
    selected: String,
    invalid: Boolean,
  },
  components: {
    CategoryInfo,
  },
  computed: {
    ...mapGetters(['payee']),
    categoryOptions() {
      return (this.payee?.categories || [])
        .filter((x) => x.isActive)
        .map((x) => ({
          key: x.id,
          text: x.name,
        }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../payers/style.scss";

 .sort-option-selected  {
    background-color: #fff;
    border: 1px solid #ced4da;
    display: flex;
    align-items: center;
    min-height: 38px;
    border-radius: 1rem;

    &.invalid {
      border-color: $red;
    }
  }

  .category-row::v-deep .color-box {
    margin-right: 10px;
  }

  .sort-option.active {
    font-weight: 500;
    color: inherit;
  }
</style>
